import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import GraphHoverCardSelfieImage from 'dashboard/components/GraphHoverCardSelfieImage';
import { UppercaseLabel } from 'dashboard/components/Typography';
import {
  THRESHOLD_EXACT_MATCH_FACE,
  THRESHOLD_VERY_HIGH_FACE,
} from 'dashboard/lib/constants/similarity-selfie';
import { HydratedAccountSimilaritySelfie } from 'dashboard/models/graph-hydration';
import Sticker, { LabelBackgrounds } from 'design-system/components/Sticker';
import {
  ACCOUNT_SIMILARITY_SELFIE_DATUM_TYPE,
  DATUM_TYPE_DISPLAY_NAMES,
} from 'lib/constants/graph';

const SectionTitle = styled(UppercaseLabel)`
  color: ${Color.CoreSlate900};
`;

const Spacer = styled.div`
  height: ${Spacing[4]};
`;

const SideBySideContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: ${Spacing[2]};
`;

interface GraphHoverCardAccountSimilaritySelfieProps {
  hydratedAccountSimilaritySelfie: HydratedAccountSimilaritySelfie;
}

const GraphHoverCardAccountSimilaritySelfie = ({
  hydratedAccountSimilaritySelfie,
}: GraphHoverCardAccountSimilaritySelfieProps) => {
  const serverHydratedAccountSimilaritySelfie = hydratedAccountSimilaritySelfie.hydrationData;
  const {
    account1: { id: account1Id, selfies: account1Selfies },
    account2: { id: account2Id, selfies: account2Selfies },
    confidence,
  } = serverHydratedAccountSimilaritySelfie;

  // Mirrors logic in AccountSelfiesSection
  const {
    text: confidenceText,
    color: confidenceColor,
  }: { text: string; color: LabelBackgrounds } =
    confidence >= THRESHOLD_EXACT_MATCH_FACE
      ? {
          text: 'Exact Match',
          color: 'red',
        }
      : confidence > THRESHOLD_VERY_HIGH_FACE
        ? {
            text: 'Very High',
            color: 'pink',
          }
        : {
            text: 'High',
            color: 'yellow',
          };

  return (
    <>
      <SectionTitle>
        {DATUM_TYPE_DISPLAY_NAMES[ACCOUNT_SIMILARITY_SELFIE_DATUM_TYPE.token]}
      </SectionTitle>
      <Sticker variant={confidenceColor}>{confidenceText}</Sticker>
      <Spacer />
      <SideBySideContainer>
        <a href={`/dashboard/accounts/${account1Id}`}>
          {account1Selfies && account1Selfies.length > 0 ? (
            <GraphHoverCardSelfieImage selfieFile={account1Selfies[0]} />
          ) : null}
        </a>
        <a href={`/dashboard/accounts/${account2Id}`}>
          {account2Selfies && account2Selfies.length > 0 ? (
            <GraphHoverCardSelfieImage selfieFile={account2Selfies[0]} />
          ) : null}
        </a>
      </SideBySideContainer>
    </>
  );
};

export default GraphHoverCardAccountSimilaritySelfie;
